import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "envelope",
  "use": "envelope-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"envelope\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h40v40H0z\" /><g stroke=\"currentColor\"><path d=\"M9.5 12H29c.828 0 1.5.762 1.5 1.7v13.6c0 .938-.672 1.7-1.5 1.7H9.5c-.828 0-1.5-.762-1.5-1.7V13.7c0-.938.672-1.7 1.5-1.7z\" /><path d=\"M30.13 13l-9.513 7.512a2.16 2.16 0 01-2.734 0L8.37 13\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol